module.exports = __webpack_public_path__ + "img/1450297631.e573f568.jpg";